// Schema versions - keep in sync with UBE team definitions
export const SCHEMA_VERSION = {
    OBJECT_INTERACTED: 13,
    MODAL_VIEWED: 4,
    MODAL_CLICKED: 15,
} as const;

// Event names
export const UBE_EVENT = {
    OBJECT_INTERACTED: "SearchUI_ObjectInteracted",
    MODAL_VIEWED: "CoreUI_ModalViewed",
    MODAL_CLICKED: "CoreUI_ModalClicked",
} as const;
